export default __webpack_public_path__ + "static/media/3.4ccaa5a7.webp";